// Sidebar-friendly Agentic Mode toggle.
// OFF: neutral, sits flat alongside other sidebar items.
// ON: lime fill with live pulse indicator — clearly "active".
import { cn } from '@/lib/utils'
import AgentMark from './AgentMark'

interface AgenticModeToggleProps {
    checked: boolean
    onCheckedChange: (next: boolean) => void
    disabled?: boolean
    className?: string
}

function AgenticModeToggle({
    checked,
    onCheckedChange,
    disabled,
    className,
}: AgenticModeToggleProps) {
    return (
        <button
            type='button'
            disabled={disabled}
            aria-pressed={checked}
            onClick={() => onCheckedChange(!checked)}
            className={cn(
                // Shape, color tokens, and shadow mirror the workspace "Create a survey" CTA
                // (--accent / --accent-ink / --shadow-soft). The CSS vars are scoped to
                // .agent-console, so we inline the exact oklch values here.
                'group flex w-full cursor-pointer items-center justify-between gap-2 rounded-full px-3.5 py-2',
                'text-[12.5px] font-semibold tracking-tight transition-all duration-150',
                'shadow-[0_1px_0_oklch(0.16_0.015_150_/_0.04),0_6px_18px_oklch(0.16_0.015_150_/_0.06)]',
                'hover:-translate-y-px',
                'focus:outline-none focus-visible:ring-2 focus-visible:ring-[oklch(0.16_0.015_150_/_0.55)] focus-visible:ring-offset-2 focus-visible:ring-offset-[#FAFAFA]',
                'disabled:cursor-not-allowed disabled:opacity-50',
                checked
                    ? 'bg-[oklch(0.88_0.19_130)] text-[oklch(0.28_0.06_140)] hover:bg-[oklch(0.84_0.19_130)]'
                    : 'bg-white text-[oklch(0.28_0.06_140)] hover:bg-[oklch(0.94_0.08_130)]',
                className,
            )}
        >
            <AgentMark
                size={14}
                className='text-[oklch(0.28_0.06_140)] opacity-90'
            />
            <span className='flex-1 text-left'>Agentic Mode</span>
            {checked ? (
                <span className='ml-auto inline-flex items-center gap-1 rounded-full bg-[oklch(0.28_0.06_140)] px-1.5 py-0.5 text-[9px] font-[700] uppercase tracking-[0.08em] text-[oklch(0.88_0.19_130)]'>
                    <span className='relative inline-flex h-1 w-1'>
                        <span className='absolute inline-flex h-full w-full animate-ping rounded-full bg-[oklch(0.88_0.19_130)] opacity-70' />
                        <span className='relative inline-flex h-1 w-1 rounded-full bg-[oklch(0.88_0.19_130)]' />
                    </span>
                    On
                </span>
            ) : (
                <span className='ml-auto text-[9px] font-[700] uppercase tracking-[0.08em] text-[oklch(0.28_0.06_140_/_0.55)]'>
                    Off
                </span>
            )}
        </button>
    )
}

export default AgenticModeToggle
export type { AgenticModeToggleProps }
